import { createAction } from 'redux-actions';
import axios from 'axios';
import MeService from '../../services/MeService';
export const FETCH_USER_INFO_PENDING = createAction('FETCH_USER_INFO_PENDING');
export const FETCH_USER_INFO_SUCCESS = createAction('FETCH_USER_INFO_SUCCESS');
export const FETCH_USER_INFO_ERROR = createAction('FETCH_USER_INFO_ERROR');

export const handleGetUserInfo = () => {
    return async (dispatch, getState) => {
        const cancelToken = axios.CancelToken.source();
        dispatch(FETCH_USER_INFO_PENDING(cancelToken));
        try{
            const result = await MeService.userInfo();   
            dispatch(FETCH_USER_INFO_SUCCESS(result.data.profile_picture_thumbnail));
            localStorage.setItem('userProfilePictureThumbnail',  result.data.profile_picture_thumbnail);
        }catch (error) {
          dispatch(FETCH_USER_INFO_ERROR(`Error: ${error}`));                     
        }
    };
};

